import { HighLevelSolidityType } from '@mls-wallet/shared-types';
import {
  TransactionBuilderParameterInputProps,
  TransactionBuilderParameterState,
} from './types';
import {
  getDefaultFieldStateForParameterType,
  getValueTypeFromSolidityType,
} from './utils';
import { AddressInput } from './AddressInput';
import { NumberInputField } from './NumberInput';
import { StringInput } from './StringInput';
import { BooleanInput } from './BooleanInput';
import { BytesInput } from './BytesInput';
import { ArrayInput } from './ArrayInput';
import { StructInput } from './StructInput';
import { GenericInput } from './GenericInput';

export function ParameterInput(
  props: TransactionBuilderParameterInputProps
): React.ReactElement {
  const valueType = getValueTypeFromSolidityType(props.paramAbiFragment.type);

  switch (valueType) {
    case HighLevelSolidityType.ADDRESS:
      // Case: address param
      return <AddressInput {...props} />;
    case HighLevelSolidityType.NUMBER:
      // Case: number param
      return <NumberInputField {...props} />;
    case HighLevelSolidityType.STRING:
      // Case: string param
      return <StringInput {...props} />;
    case HighLevelSolidityType.BOOLEAN:
      // Case: boolean param
      return <BooleanInput {...props} />;
    case HighLevelSolidityType.BYTES:
      // Case: bytes param
      return <BytesInput {...props} />;
    case HighLevelSolidityType.ARRAY:
      // Case: array param
      return <ArrayInput {...props} />;
    case HighLevelSolidityType.STRUCT_OR_TUPLE:
      // Case: struct or tuple param
      return <StructInput {...props} />;
    default:
      // Case: some other param we're not accounting for
      return <GenericInput {...props} />;
  }
}

/**
 * Helper to initialize parameter states for a function ABI
 */
export function buildDefaultParameterStates(
  inputs: import('viem').AbiParameter[]
): TransactionBuilderParameterState[] {
  return inputs.map((param) => getDefaultFieldStateForParameterType(param));
}
